import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import resumePdf from "../../assets/resume/Jacob Rajan resume.pdf";
import img1 from "../../assets/images/layouts/banner.png";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import Typed from "typed.js";

function Banner() {
  const typedRef = useRef(null);
  const typedInstance = useRef(null);

  useEffect(() => {
    // Configuration for Typed.js
    const options = {
      strings: ["Designer", "Developer", "Programmer"],
      typeSpeed: 50,
      backSpeed: 50,
      loop: true,
      backDelay: 1000,
    };

    // Initialize Typed.js
    if (typedRef.current) {
      typedInstance.current = new Typed(typedRef.current, options);
    }

    // Cleanup on unmount
    return () => {
      if (typedInstance.current) {
        typedInstance.current.destroy();
      }
    };
  }, []);

  return (
    <section className="banner">
      <div className="shape right"></div>
      <div className="container">
        <div className="row">
          <div className="col-xl-7 col-md-12 d-flex">
            <div className="banner__left">
              <div className="block-text">
                <div className="heading">
                  A Web
                  <span className="typed_title">
                    <span ref={typedRef}></span>
                  </span>
                  <h1 className="name">Jacob Rajan</h1>
                </div>
                <p className="desc">
                  Full-stack developer specializing in building exceptional
                  digital experiences. Turning complex problems into elegant
                  solutions.
                </p>

                <a
                  href={resumePdf}
                  className="action-btn"
                  download="Jacob Rajan Resume.pdf"
                >
                  <span>
                    Download Resume <Download className="download-btn" />
                  </span>
                </a>
              </div>

              <div className="pay">
                <h6>Follow Me</h6>

                <div className="list">
                  {/* <p>We accept:</p> */}

                  <ul>
                    <li>
                      <Link to="https://www.linkedin.com/in/imjacobrajan/">
                        <span className="icon-logo-01">
                          <FaLinkedin />
                        </span>
                      </Link>
                    </li>
                    <li>
                      <a href="https://github.com/imjacobrajan" target="_blank" rel="noreferrer">
                        <span className="icon-logo-02">
                          <FaGithub />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-md-12">
            <div className="banner__right">
              <div className="image">
                <img src={img1} alt="cyfonii" />
              </div>

              <div className="price">
                <div className="icon">
                  <h1>
                    7 <sup>+</sup>
                  </h1>
                </div>
                <div className="content">
                  <p>years of</p>
                  <h5>Experience</h5>
                </div>
              </div>


              <div className="owner">
                <div className="image" style={{
                  background: 'linear-gradient(135deg, #5c27fe 0%, #9b6dff 100%)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  borderRadius: '50%', width: 52, height: 52, flexShrink: 0,
                }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, letterSpacing: 1, lineHeight: 1, fontFamily: '"Poppins", sans-serif' }}>JR</span>
                </div>
                <div className="content">
                  <h5>Jacob Rajan</h5>
                  <p>@imjacobrajan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
